module.exports = __webpack_public_path__ + "img/home-circle-icon.1eabc0ce.png";